import { Tv } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <header className="flex items-center justify-between flex-wrap gap-5 px-3 sm:px-8 py-5 backdrop-blur-md bg-white/70 sticky top-0 z-50 border-b border-gray-200">
            <Link to="/" className="flex items-center justify-center gap-3">
                {/* <Tv className="h-8 w-8 text-black" /> */}
                <img src='./images/ctv_logo.png' className="h-12 w-12 text-black"/>
                <span className="text-2xl font-bold tracking-tight mt-[9px]">
                    SocialTV
                </span>
            </Link>

            <nav className="flex items-center gap-3">
                <Link to="/sign-in" className="hover:text-black/70 transition rounded-xl border border-gray-200 px-4 py-2">
                    Login
                </Link>
                <Link
                    to="/dashboard"
                    className="bg-black text-white px-4 py-2 rounded-xl hover:bg-gray-900 transition shadow-md"
                >
                    Get Started
                </Link>
            </nav>
        </header>
    )
}

export default Header